Object.defineProperty(exports, "__esModule", { value: true });
exports.fieldDefautls = void 0;
const commonFieldDefaults = {
    localized: false,
    name: '%Field name%',
    required: false,
};
const checkbox = {
    initialContent: ['%firstItem%'],
    items: ['check', 'box'],
    type: 'checkbox',
};
const date = {
    initialContent: '2019-06-03T00:00+01:00',
    type: 'date',
};
const dropdown = {
    initialContent: '%firstItem%',
    items: ['drop', 'down'],
    type: 'dropdown',
};
const media = {
    initialContent: true,
    type: 'media',
};
const longText = {
    initialContent: 'Initial content for long text field',
    type: 'longText',
};
const multipleComponents = {
    allowedComponents: ['%firstAllowedComponent%'],
    initialContent: ['%firstAllowedComponent%'],
    type: 'multipleComponents',
};
const number = {
    initialContent: 5,
    type: 'number',
};
const richText = {
    initialContent: 'Initial content for rich text field',
    type: 'richText',
};
const shortText = {
    initialContent: 'Initial content for short text field',
    type: 'shortText',
};
const singleComponent = {
    allowedComponents: ['%firstAllowedComponent%'],
    initialContent: '%firstAllowedComponent%',
    type: 'singleComponent',
};
const tags = {
    initialContent: ['bright', 'brighter', 'brightest'],
    type: 'tags',
};
exports.fieldDefautls = {
    commonFieldDefaults,
    fieldTypeDefaults: {
        checkbox,
        date,
        dropdown,
        media,
        longText,
        multipleComponents,
        number,
        richText,
        shortText,
        singleComponent,
        tags,
    },
};
//# sourceMappingURL=field-defaults.js.map